<div class="wrap">
    <header>
        <h3 class="heading">{{ data.translatedValues.title }}</h3>
        <button class="close-button" (click)="close()"><span class="icon-close"></span></button>
    </header>
    <div class="content">
        <div class="infos">
            {{ data.translatedValues.infos }}
        </div>
        <form [formGroup]="form">
            <div formGroupName="cta">
                <div *ngFor="let language of data.langs" class="lang-input-wrapper">
                    <app-form-input
                        [label]="data.translatedValues.name[language].label"
                        [placeholder]="data.translatedValues.name[language].placeholder"
                        [formControlName]="language">
                        <app-form-error *ngIf="cta.get(language).touched && cta.get(language).hasError('required')">
                            {{ data.translatedValues.name[language].error.required}} 
                        </app-form-error>
                    </app-form-input>
                </div>
            </div>
            <app-form-input
                [label]="data.translatedValues.link.label"
                [placeholder]="data.translatedValues.link.placeholder"
                formControlName="link">
                <app-form-error *ngIf="link.touched && link.hasError('required')">
                    {{ data.translatedValues.link.error.required }}
                </app-form-error>
            </app-form-input>
        </form>
    </div>
    <footer>
        <button class="bciti-button bciti-button--lightblue-inversed" (click)="onCancel()">
            {{ data.translatedValues.cancelButton.text }}
        </button>
        <button 
            class="bciti-button bciti-button--blue" 
            (click)="onSubmit()"
        >
            <span>
                {{ data.translatedValues.submitButton.text }}
            </span>
        </button>
    </footer>
</div>
